import { CHECKOUT_ITEM_TYPE_EXPERIENCE, CHECKOUT_ITEM_TYPE_TRANSFER } from 'constants/checkout'
import { isAccommodationItem } from 'lib/checkout/checkoutUtils'

export function getCheckoutItemsRemovedWithItem(
  items: Array<App.Checkout.AnyItem>,
  itemId: string,
): Array<App.Checkout.AnyItem> {
  const removedItem = items.find(item => item.itemId === itemId)
  if (!removedItem) return []

  const removedBundleId = 'isAccomBundle' in removedItem ? removedItem.isAccomBundle : undefined
  const shouldRemoveBundledExperience = !!removedBundleId &&
    !items.some(item =>
      item.itemId !== itemId &&
      isAccommodationItem(item) &&
      'isAccomBundle' in item &&
      item.isAccomBundle === removedBundleId,
    )
  const bundledExperienceIdsToRemove = shouldRemoveBundledExperience
    ? items
        .filter(item => {
          if (!(item.itemType === CHECKOUT_ITEM_TYPE_EXPERIENCE || item.itemType === CHECKOUT_ITEM_TYPE_TRANSFER)) return false

          return item.isAccomBundle === removedBundleId
        })
        .map(item => item.itemId)
    : []
  const itemIdsToRemove = [itemId, ...bundledExperienceIdsToRemove]

  return items.filter(item => itemIdsToRemove.includes(item.itemId))
}
